import type { ClassifySibling } from "../api/client";
import styles from "./ClassifyDetailPanel.module.css";

/**
 * Cross-document sibling select + action button (5d-4b move / merge).
 * Extracted from ClassifyDetailPanel.tsx (R-260 CS-station cleanup).
 *
 * Presentational — the parent owns the selected value and the action wiring
 * (via useParkedDocAction), so move and merge share one component. Renders just
 * the select + button fragment; the call site supplies any wrapping element.
 */
const VARIANTS = {
  move: { selectLabel: "Move page to", placeholder: "Move page to…", button: "Move page" },
  merge: { selectLabel: "Merge document", placeholder: "Merge sibling into this…", button: "Merge" },
} as const;

export function MoveMergeControl({
  variant,
  siblings,
  value,
  busy,
  onChange,
  onSubmit,
}: {
  variant: "move" | "merge";
  siblings: ClassifySibling[];
  value: string;
  busy: boolean;
  onChange: (value: string) => void;
  onSubmit: () => void;
}) {
  const cfg = VARIANTS[variant];
  return (
    <>
      <select
        className={styles.formSelect}
        aria-label={cfg.selectLabel}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={busy}
      >
        <option value="">{cfg.placeholder}</option>
        {siblings.map((s) => (
          <option key={s.id} value={s.id}>
            {`${s.displayId ?? s.filename} (${s.formName ?? "unidentified"})`}
          </option>
        ))}
      </select>
      <button
        type="button"
        className={styles.btn}
        disabled={!value || busy}
        onClick={onSubmit}
      >
        {cfg.button}
      </button>
    </>
  );
}
